import { Row } from 'antd';
import styled from 'styled-components';
import { Checkbox as AntdCheckbox } from 'components/atoms/checkbox';
import { Form } from 'components/atoms/form';
import { ProductiveHeading07, Text02 } from 'components/styles';

export const Container = styled.div``;
export const Heading = styled.div`
  ${ProductiveHeading07};
  ${Text02};
  display: flex;
  align-items: center;
`;
export const Content = styled.div``;
export const ProjectTabsVisibilityWrapper = styled.div`
  padding: var(--spacing-08);
`;
export const TabVisibilityHeading = styled(Heading)`
  margin-bottom: var(--spacing-02);
`;
export const TitleRow = styled(Row)`
  margin-bottom: var(--spacing-03);
`;

export const Checkbox = styled(AntdCheckbox)`
  display: flex;
  align-items: center;
`;

export const OptionsRow = styled(Row)`
  .ant-checkbox-group {
    display: grid;
    grid-template-columns: 1fr 1fr;
    width: 500px;
    .ant-checkbox-group-item {
      justify-self: start;
    }
  }
`;

export const FormWithMarginTop = styled(Form)`
  margin-top: var(--spacing-05);
`;
